import React, {useEffect} from "react";
import {useCurrentUser} from "../../hooks/use-current-user";
import {useAllGains} from "../../hooks/use-gains";
import {AdminGainListItem} from "../../components/AdminGainListItem";
import {SpinnerPadded} from "../../components/SpinnerPadded";
import {getDocs} from "@firebase/firestore";

export function AdminGainsTab() {
    const {user, authUser, userLoading} = useCurrentUser();
    const {allGains, gainsLoading, gainsQuery} = useAllGains();
    useEffect(() => {
        if (gainsQuery) getDocs(gainsQuery).then();
    }, [gainsQuery]);

    return (<div>
        <h3 className={"primary-color"}>All Purchases</h3>
        <p>Review your gains history below.</p>
        {(gainsLoading || userLoading) && <SpinnerPadded/>}
        {userLoading || allGains?.map(gain =>
            <AdminGainListItem key={gain.id} hasActions={true} gainData={gain}/>)}
    </div>);
}
